import React from "react";
import { announcementService } from "./model/service";
import EAnnouncements from "./view/_announcements";
export default function E_Announcements({ keyWord, searchAnnData }) {
  return (
    <EAnnouncements
      getAnnouncementsData={announcementService.getAndSortAnnouncementData}
      keyWord={keyWord}
      searchAnnData={searchAnnData}
    />
  );
}
